var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * `GET /users/:patientId/video-reach` (#1856): whether a video appointment for
 * this patient would be booked. False when the patient has neither a Contact
 * address for the TAN nor a Caregiver entry with `REGISTERED` access — the
 * booking itself is then refused with 422.
 */
export class PatientVideoReachDto {
    reachable;
}
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], PatientVideoReachDto.prototype, "reachable", void 0);
//# sourceMappingURL=patient-video-reach.dto.js.map